import utils from 'helpers/utils';
import constants from 'helpers/constants';

function createQuery (name = 'Search', parts = [], filters = {}, searchQuerySourceType = null, advanced = false, inUniverse = false, collectionId = null) {
  return {
    id: utils.sha1(name),
    version: 1,
    name,
    parts,
    filters,
    advanced,
    inUniverse,
    collectionId,
    searchQuerySourceType,
    suggestions: [],
    tools: {
      translations: ['en'],
      extensions: ['ss'],
      noiseReduction: ['articles', 'patents']
    }
  };
}

function initQuery (query, terms, wizard, examples, similarity, filter) {
  let clear = false;
  if (!utils.isEmpty(query)) {
    query = utils.clone(query, true);

    clear = utils.isDefined(terms) ||
      utils.isDefined(wizard) ||
      utils.isDefined(examples) ||
      utils.isDefined(filter);
  } else {
    query = createQuery();
  }

  if (terms?.length > 0 || wizard || examples?.length > 0) {
    const partId = utils.sha1(`${query.id}_${0}`);

    query.parts = [];
    query.version = 1;

    if (wizard) {
      let part = {
        id: partId,
        queryType: constants.query.partTypes.and,
        filterOperator: similarity === constants.query.similarityTypes.weak ? constants.query.filterOperators.similar : constants.query.filterOperators.match,
        wizard: wizard
      };

      query.parts.push({...part, id: utils.sha1(`${partId}_wizard`)});
    }

    if (examples?.length > 0) {
      let part = {
        id: partId,
        queryType: constants.query.partTypes.and,
        filterOperator: similarity === constants.query.similarityTypes.weak ? constants.query.filterOperators.similar : constants.query.filterOperators.match,
        examples: examples
      };

      query.parts.push({...part, id: utils.sha1(`${partId}_examples`)});
    }

    if (terms?.length > 0) {
      let part = {
        id: partId,
        queryType: constants.query.partTypes.and,
        termsFunctor: constants.query.termFunctors.or,
        terms: terms.map((t, idx) => {
          return {
            id: utils.sha1(`${partId}_${idx}_${t.value}`),
            term: t
          };
        })
      };

      query.parts.push({...part, id: utils.sha1(`${partId}_terms`)});
    }
  } else if (clear) {
    query.version = 1;
    query.parts = [];
  }

  if (!utils.isEmpty(filter)) {
    query.filters = utils.filter2Object(filter);
  } else if (clear) {
    query.filters = {};
  }

  return query;
}

function clearQuery (query) {
  query = utils.clone(query, true);

  query.parts = [];
  query.filters = {};

  return query;
}

function simpleQuery (query, terms, wizard, examples, similarity) {
  query = initQuery(query, terms, wizard, examples, similarity);
  delete query.advanced;
  delete query.assistant;

  return query;
}

function advancedQuery (query, terms, wizard, examples, similarity) {
  query = initQuery(query, terms, wizard, examples, similarity);
  query.advanced = true;
  delete query.assistant;

  return query;
}

function assistantQuery (query, terms, wizard, examples, similarity) {
  query = initQuery(query, terms, wizard, examples, similarity);
  query.assistant = true;

  return query;
}

function searchTextToTerms(search) {
  let terms = [];

  const match = (search.match(/["][^"]+["]/g) || []).concat(search.match(/['][^']+[']/g) || []);

  if (match) {
    match.forEach((s) => {
      if (s.trim().length > 0) {
        search = search.split(s).join('');
        s = s.slice(1, s.length - 1);
        terms.push({
          exactMatch: true,
          value: s
        });
      }
    });
  }

  let split = search.split(/[\s,]+/);
  split.forEach((s, idx) => {
    if (s.trim().length > 0) {
      if (idx === 0 || idx === split.length - 1 || !['and', 'or'].includes(s.trim().toLowerCase()))
        terms.push({
          exactMatch: false,
          value: s
        });
    }
  });

  return terms;
}

const cleanQuery = (query) => {
  delete query.version;
  delete query.advanced;
  delete query.assistant;
  return query;
}

const isExactMatch = (term) => {
  return (term.length > 1 && term[0] === term[term.length - 1] && (term[0] === '"')) ||
    term.trim().search(/[\s,-]/) !== -1;
}

const filterCount = (query) => {
  return (query?.parts?.reduce((t, p) => t + filterCount(p), 0) ?? 0) +
    ((query?.terms?.length > 0 || query?.wizard?.length > 0 || query?.examples?.length > 0 ||
      Object.keys(query?.filter ?? {}).length > 0) ? 1 : 0);
}

const search = {
  createQuery,
  clearQuery,
  simpleQuery,
  advancedQuery,
  assistantQuery,
  cleanQuery,
  isExactMatch,
  filterCount,
  searchTextToTerms
};

export default search;


